import React from 'react';

/**
 * Inline SVG icons (Lucide-style, 24x24 viewBox, stroke = currentColor) used in
 * place of emoji so they render crisply and inherit the surrounding text color.
 */
export interface IconProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Icon: React.FC<IconProps & { children: React.ReactNode }> = ({
  size = 16,
  className,
  style,
  children,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    style={{ verticalAlign: 'middle', ...style }}
  >
    {children}
  </svg>
);

/** Video-camera icon for Video Visit mode. */
export const VideoVisitIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}>
    <path d="m22 8-6 4 6 4V8Z" />
    <rect width="14" height="12" x="2" y="6" rx="2" ry="2" />
  </Icon>
);

/** Stethoscope icon for In-Person visit mode. */
export const InPersonIcon: React.FC<IconProps> = (p) => (
  <Icon {...p}>
    <path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
    <path d="M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4" />
    <circle cx="20" cy="10" r="2" />
  </Icon>
);
